import React from "react";

import { useTranslation, Trans } from "react-i18next";

import Button from '../Button'

import f1 from '../../img/SupportAndFaq/f1.png';
import f2 from '../../img/SupportAndFaq/f2.png';
import f3 from '../../img/SupportAndFaq/f3.png';

import v1 from '../../img/SupportAndFaq/vec1.png';
import v2 from '../../img/SupportAndFaq/vec2.png';
import v3 from '../../img/SupportAndFaq/vec3.png';

import button from '../../img/SupportAndFaq/button.png';

import Fade from 'react-reveal/Fade';

function Main () {

    const { t } = useTranslation();
      
    return(
        <div className="overflow-hidden relative pt-[40px] xl:pt-[70px]">
            <div className="max-w-[1220px] xl:mx-auto">
                <div className="flex flex-col md:flex-row justify-between gap-[20px] mx-[20px] xl:mx-0">
                    <div className="flex flex-col items-center xl:items-start mx-auto xl:mx-0">
                        <p className="text-[32px] xl:text-[50px] italic font-[700] merriweather">{t('supandfaq.1')}</p>
                        <p className="mt-[30px] inter text-[14px] xl:text-[16px] font-[300] md:max-w-[525px] fdfd text-center xl:text-left"><Trans>{t('supandfaq.2')}</Trans></p>
                        <Button className={"mt-[30px] xl:mt-[40px]"}/>
                    </div>
                    <div className="hidden xl:block">
                        <p className="mt-[30px] inter text-[14px] xl:text-[16px] font-[700]"><Trans>{t('supandfaq.3')}</Trans></p>
                        <p className="mt-[20px] inter text-[14px] xl:text-[16px] font-[300] md:max-w-[525px] fdfd text-center md:text-left"><Trans>{t('supandfaq.4')}</Trans></p>     
                    </div>
                </div>
                <div className="flex flex-col-reverse xl:flex-row justify-between">
                    <div className="mx-[20px] xl:mx-0">
                        <p className="mt-[30px] inter text-[14px] xl:text-[16px] font-[700]"><Trans>{t('supandfaq.5')}</Trans></p>
                        <p className="mt-[20px] inter text-[14px] xl:text-[16px] font-[300] xl:max-w-[525px] fdfd"><Trans>{t('supandfaq.6')}</Trans></p>     
                    </div>
                    <div className="bg-[#666666] h-[420px] md:h-[649px] w-full md:w-[574px] mt-[20px] xl:mt-0 rounded-tl-[150px] relative overflow-hidden mx-auto xl:mx-0">
                        <div className="flex">
                            <div className="bg-[#0BD752] w-1/2 md:w-[287px] h-[190px] md:h-[291px] flex items-center justify-center">
                                <img src={f1} alt="" className="w-[120px] md:w-auto"/>
                            </div>
                            <div className="absolute right-[25px] md:right-[35px] top-[25px] md:top-[35px]">
                                <img src={f2} alt="" className="w-[140px] md:w-auto"/>
                                <Fade top><img src={button} alt="" className="absolute bottom-[25px] md:bottom-[35px] left-[18px] md:left-1/4 -translate-x-1/2"/></Fade>
                            </div>
                        </div>
                        <img src={f3} alt="" className="pl-[35px] pt-[13px] w-[170px] md:w-auto"/>
                    </div>
                </div>
                <div className="w-full h-[756px] bg-[#353535] hidden xl:block rounded-tl-[200px] rounded-br-[200px] mt-[-358px]">
                    <div className="flex flex-col">
                        <div className="pt-[80px] pl-[85px]">
                            <p className="text-[32px] xl:text-[50px] italic font-[700] merriweather text-[#FFFFFF]"><Trans>{t('supandfaq.7')}</Trans></p>
                        </div>
                        <div className="grid grid-cols-3 mt-[180px]">
                            <div className="flex flex-col items-center gap-[20px]">
                                <img src={v1} alt="" />
                                <p className="text-center spantextt inter text-white text-[14px] xl:text-[16px] leading-[1.2]"><Trans>{t('supandfaq.8')}</Trans></p>
                            </div>
                            <div className="flex flex-col items-center gap-[20px]">
                                <img src={v2} alt="" />
                                <p className="text-center spantextt inter text-white text-[14px] xl:text-[16px] leading-[1.2]"><Trans>{t('supandfaq.9')}</Trans></p>
                            </div>
                            <div className="flex flex-col items-center gap-[20px]">
                                <img src={v3} alt="" />
                                <p className="text-center spantextt inter text-white text-[14px] xl:text-[16px] leading-[1.2]"><Trans>{t('supandfaq.10')}</Trans></p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="xl:hidden block mx-[20px] xl:mx-0">
                    <p className="mt-[30px] inter text-[14px] xl:text-[16px] font-[700]"><Trans>{t('supandfaq.3')}</Trans></p>
                    <p className="mt-[20px] inter text-[14px] xl:text-[16px] font-[300] xl:max-w-[525px] fdfd"><Trans>{t('supandfaq.4')}</Trans></p>     
                </div>
                <p className="text-[32px] xl:text-[50px] italic xl:hidden text-center font-[700] mt-[100px] merriweather text-black"><Trans>{t('supandfaq.7')}</Trans></p>
                <div className="grid grid-cols-1 md:grid-cols-3 xl:hidden gap-[30px] mt-[50px]">
                    <div className="flex flex-col items-center gap-[10px] xl:gap-[20px]">
                        <img src={v1} alt="" />
                        <p className="text-center spantextt inter text-black text-[14px] xl:text-[16px] leading-[1.2]"><Trans>{t('supandfaq.8')}</Trans></p>
                    </div>
                    <div className="flex flex-col items-center gap-[10px] xl:gap-[20px]">
                        <img src={v2} alt="" />
                        <p className="text-center spantextt inter text-black text-[14px] xl:text-[16px] leading-[1.2]"><Trans>{t('supandfaq.9')}</Trans></p>
                    </div>
                    <div className="flex flex-col items-center gap-[10px] xl:gap-[20px]">
                        <img src={v3} alt="" />
                        <p className="text-center spantextt inter text-black text-[14px] xl:text-[16px] leading-[1.2]"><Trans>{t('supandfaq.10')}</Trans></p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Main;